import { Column } from '../../../../app/components/Column/Column';
import { useThemeContext } from '../../../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../../Translations/providers/TranslationsContextProvider';
import ChatIcon from '../../../../app/assets/icons/chat.svg?react';
import {
	ChatEmptyContainer,
	ChatEmptyDescription,
	ChatEmptyTitle,
} from './style';

export function ChatEmpty() {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();

	return (
		<ChatEmptyContainer>
			<Column $gap={32} $hcenter={true} $vcenter={true}>
				<ChatIcon height={32} width={38} fill={theme.colors.neutral[300]} />
				<Column $gap={8}>
					<ChatEmptyTitle>{t('chat.empty_title')}</ChatEmptyTitle>
					<ChatEmptyDescription>{t('chat.empty_description')}</ChatEmptyDescription>
				</Column>
			</Column>
		</ChatEmptyContainer>
	);
}
